import { render, staticRenderFns } from "./CustomerCompliance.vue?vue&type=template&id=43147368"
import script from "./CustomerCompliance.vue?vue&type=script&lang=js"
export * from "./CustomerCompliance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports